import React from "react";
import { Box, FormControl, Typography } from "@mui/joy";

interface CodeInputGridProps {
  codeDigits: string[];
  onCodeChange: (index: number, value: string) => void;
  onBackspace: (index: number, e: React.KeyboardEvent) => void;
}

export const CodeInputGrid: React.FC<CodeInputGridProps> = ({
  codeDigits,
  onCodeChange,
  onBackspace,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "nowrap",
        gap: 1.5,
        px: 2,
      }}
    >
      {codeDigits.map((digit, index) => (
        <React.Fragment key={index}>
          {index === 3 && (
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: 400,
                color: "#7B7F85",
              }}
            >
              -
            </Typography>
          )}
          <FormControl
            sx={{
              width: 44,
              height: 52,
              "& input": {
                padding: 0,
                textAlign: "center",
                fontSize: "1.5rem",
                backgroundColor: "#ECEFF3",
                borderRadius: "16px",
                width: "100%",
                height: "100%",
                outline: "none",
              },
            }}
          >
            <input
              id={`code-${index}`}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={digit ? "•" : ""}
              onChange={(e) => onCodeChange(index, e.target.value)}
              onKeyDown={(e) => onBackspace(index, e)}
              autoComplete="one-time-code"
            />
          </FormControl>
        </React.Fragment>
      ))}
    </Box>
  );
};
